import { Box, Container, Grid, Hidden, Paper, Typography } from "@mui/material";
import HeaderTitle from "../common/HeaderTitle";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

export default function PageLayout({ title, Icon, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const prevState = location.state;

  return (
    <Container sx={{ pl: { md: "100px" }, mt: 3, mb: 2 }}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          className="page-header-container"
          sx={{
            padding: 3,
            height: "80px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Hidden mdUp>
            <Icon style={{ color: "#eaad32", fontSize: 38 }} />
          </Hidden>
          <Hidden smDown>
            <Icon style={{ color: "#eaad32", fontSize: 32 }} />
          </Hidden>
          <HeaderTitle title={title} />
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
}
